export const permission = {
  BUYER: ["/cart", "/account", "/checkout", "/order", "/enquiry/:id", "/invoice/:orderId"],
  BHAREE: ["/admin/profile-panel", "/invoice/:orderId", "/seller/subscription/invoice/:id"],
  SELLER: [
    "/seller/profile-panel",
    "/calculations",
    "/invoice/:orderId",
    "/seller/subscription/invoice/:id",
  ],
  LOGISTIC_PARTNER: ["/logistic-partner/profile-panel", "/invoice/:orderId"],
};

// NOTE: Change route permissions according to role if required
